import { createRootRoute, Outlet } from "@tanstack/react-router"

/**
 * The root route. Block 02 puts the real app shell — nav, auth guard,
 * error boundary — here; today it is the outlet and nothing else, so that the
 * route tree exists and block 02 has somewhere to put them.
 */
export const Route = createRootRoute({
  component: () => <Outlet />,
})
